import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { Subscription, timer } from 'rxjs';
import { ASSET_NAME, GENERIC_FILE_PREFIX } from 'src/app/app.consts';
import { ApplicationService } from 'src/app/services/application-service';
import { FlowService } from 'src/app/services/flow.service';
import { TrackingService } from 'src/app/services/tracking.service';
import { Router } from '@angular/router';
import { exclusivelyRetrieveGenericPrefix } from 'src/app/utils/filter-functions';
import { TranslateService } from '@ngx-translate/core';
import { ApplicationScoreService } from 'creddo-shared-library';

@Component({
  selector: 'app-generic-file-upload',
  templateUrl: './generic-file-upload.component.html',
  styleUrls: ['./generic-file-upload.component.scss'],
})
export class GenericFileUploadComponent implements OnInit, OnDestroy {
  applicationId!: number;
  genericFileUploadForm!: FormGroup;
  error!: string;
  assetName!: typeof ASSET_NAME;
  subs: Array<Subscription> = [];
  requestPending = false;
  currentRoute!: string;
  @Input() isSummary!: boolean;
  @Input() path!: string;

  constructor(
    private formBuilder: FormBuilder,
    private applicationService: ApplicationService,
    public flowService: FlowService,
    protected trackingService: TrackingService,
    private router: Router,
    private translateService: TranslateService,
    private applicationScoreService: ApplicationScoreService
  ) {}

  ngOnInit(): void {
    this.applicationId = this.applicationService.applicationId;

    // Set currentRoute to path when isSummary or set it to url without query params
    if (this.isSummary) this.currentRoute = this.path.slice(1);
    else this.currentRoute = this.router.url.slice(1).split('?')[0];

    const initialGenericFiles = exclusivelyRetrieveGenericPrefix(
      this.applicationService.genericFiles,
      this.currentRoute
    );

    this.genericFileUploadForm = this.formBuilder.group({
      genericFiles: this.formBuilder.array(initialGenericFiles),
    });

    this.subs.push(
      this.genericFiles.valueChanges.subscribe((v) => {
        if (this.currentRoute === 'MT940') {
          this.applicationScoreService.updateAppScore(
            this.currentRoute.toLowerCase(),
            v ? true : false
          );
        }
      })
    );

    this.assetName = ASSET_NAME;
  }

  get genericPrefix(): string {
    return GENERIC_FILE_PREFIX[this.currentRoute];
  }

  get important(): string {
    if (this.currentRoute === 'MT940') {
      return this.translateService.instant('global.important');
    }
    return '';
  }

  ngOnDestroy(): void {
    this.subs.map((sub) => sub.unsubscribe());
  }

  trackFields(field: string): void {
    this.trackingService.filledField(field);
  }

  handleBackButtonClick(): void {
    this.subs.push(
      timer(1000, 1000).subscribe(() => {
        if (!this.requestPending) {
          this.flowService.previousScreen();
        }
      })
    );
  }

  handleNextButtonClick(): void {
    this.subs.push(
      timer(1000, 1000).subscribe(() => {
        if (!this.requestPending) {
          this.flowService.nextScreen();
        }
      })
    );
  }

  get form(): FormGroup {
    return this.genericFileUploadForm;
  }

  get genericFiles(): FormArray {
    return this.form.get('genericFiles') as FormArray;
  }
}
